export enum PersonType {
  Coowner1 = 'coowner1',
  Coowner2 = 'coowner2',
  Insurant = 'insurant',
  Owner = 'owner',
}
